import React, { useMemo, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../../components/buttons/buttons";
import Table from "../../../../../components/tables/tableCols1";
import TableSkeleton from "../../../../../components/skeleton/table";
import TableFilter from "../../../../../components/tables/tableFilter";
import { Pagination } from "../../../../../components/pagination/pagination";
import FoodImage from "../../../../../assets/images/emptyState/restaurant-list.jpg";
import EmptyState from "../../../../../assets/images/emptyState/restaurant.svg";
import { Beat } from "../../../../../plugins/spinners.plugin";
import { writeFileWithXLSX } from "../../../../../components/exports/xlsx";
import FilterFoodDropDown from "../../../../../components/dropDown/filter/filterFood";
import { AllFiltersModal } from "../../../../../components/modals/allFiltersModal";
import {
  filterFoodAction,
  searchFoodAction,
  getAllFoodNoPagination,
} from "../../../../../redux/food/foodActions";
import foodType from "../../../../../redux/food/foodTypes";
import { getOutletFromCookies } from "../../../../../utils/Auth";

export default function Unpublished() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const outlet = getOutletFromCookies();
  const { page } = useParams();

  const [isFilterOpen, setFilterState] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const [data, setData] = useState([]);
  const [input, setInput] = useState({
    search: "",
    restaurant_id: outlet?.id,
  });
  const [payLoad] = useState({
    restaurant_id: outlet.id,
    visibility: "private",
  });
  const { allFood, downloading } = useSelector((state) => state.food);
  const { filtering, searching } = useSelector((state) => state.food);

  useEffect(() => {
    dispatch(filterFoodAction(payLoad, page));
    // eslint-disable-next-line
  }, [page]);

  function createTableData(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((food, index) => {
        let show = {
          id: index + 1,
          image: (
            <img
              src={
                food?.food_pictures?.length > 0
                  ? food?.food_pictures?.[0]
                  : FoodImage
              }
              className="w-[64px] h-[54px] object-cover"
              alt="food"
            />
          ),
          name: food?.food_name,
          price: food?.food_amount,
          category: food?.food_categories?.[0],
          quantity: food?.stock,
          status: (
            <span>
              {food?.food_operating_status === "available" ? (
                <span className="text-[#00D220]">Available</span>
              ) : (
                <span className="text-primary">Unavailable</span>
              )}
            </span>
          ),
          foodData: food,
        };
        outputArray.push({ show });
        return true;
      });
      return outputArray;
    }
  }

  function createTableDataDownload(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((food, index) => {
        let show = {
          id: index + 1,
          name: food?.food_name,
          price: food?.food_amount,
          category: food?.food_categories?.[0],
          quantity: food?.stock,
          status: food?.food_operating_status,
        };
        outputArray.push(show);
        return true;
      });
      return outputArray;
    }
  }

  useEffect(() => {
    const dataSet = createTableData(allFood?.data);
    setData(dataSet);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allFood]);

  function goToCreate() {
    navigate(`/admin/${outlet?.restaurant_name}/food/create`);
  }

  function goToSinglePage(params) {
    let id = params?.show?.foodData?.id;
    navigate(`/admin/${outlet?.restaurant_name}/food/details/${id}`, {
      state: { food: params?.show?.foodData },
    });
  }

  const handleDownload = async () => {
    const response = await dispatch(
      getAllFoodNoPagination({
        ...payLoad,
        pagination: 0,
      })
    );
    if (response) {
      const newData = createTableDataDownload(response?.data);
      writeFileWithXLSX(newData, {
        filename: "All_Foods.xlsx",
        download: true,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setInput({ ...input, [name]: value });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      doSearch();
    }
  };

  const showSearch = (search) => {
    let dataSet = createTableData(search);
    setData(dataSet);
    setIsSearchOpen(true);
  };

  const removeSearch = () => {
    if (input?.search?.length === 0) {
      let dataSet = createTableData(allFood?.data);
      setData(dataSet);
      setIsSearchOpen(false);
      dispatch({
        type: foodType["SEARCH_FOOD"],
        payLoad: { data: [] },
      });
    }
  };

  async function doSearch() {
    try {
      let response = await dispatch(searchFoodAction(input));
      if (response?.status === "success") {
        showSearch(response?.data);
      }
      if (!response?.status) {
        showSearch([]);
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (input?.search?.length === 0) {
      removeSearch();
    }
    // eslint-disable-next-line
  }, [input, dispatch]);

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        // First group columns
        columns: [
          {
            Header: "S/N",
            accessor: "show.id",
          },
          {
            Header: "Image",
            accessor: "show.image",
          },
          {
            Header: "Name",
            accessor: "show.name",
          },
          {
            Header: "Price (NGN)",
            accessor: "show.price",
          },
          {
            Header: "Category",
            accessor: "show.category",
          },
          {
            Header: "Stock",
            accessor: "show.quantity",
          },
          {
            Header: "Status",
            accessor: "show.status",
          },
        ],
      },
    ],
    []
  );
  return (
    <div data-test="Food-page">
      <TableFilter
        title="Food"
        results={allFood?.to}
        totalResults={allFood?.total}
        onChange={handleChange}
        handleKeyDown={handleKeyDown}
        searchPlaceholder={"Search food name, id, price..."}
        filter={
          <AllFiltersModal
            isFilterOpen={isFilterOpen}
            setFilterState={setFilterState}
          >
            <FilterFoodDropDown
              isFilterOpen={isFilterOpen}
              setFilterState={setFilterState}
              payLoad={payLoad}
            />
          </AllFiltersModal>
        }
      >
        <Button.Primary title={"+ Create Food"} onClick={goToCreate} />
        <Button.Secondary
          title={downloading ? <Beat color={"#CE2600"} /> : "Download CSV"}
          type="button"
          disabled={!data}
          onClick={handleDownload}
        />
      </TableFilter>

      <div className="border-b border-[#E4E4F3]"></div>

      <div className="bg-white dark:bg-[#121212] rounded-md py-4">
        {filtering || searching ? (
          <TableSkeleton />
        ) : data?.length > 0 ? (
          <Table
            columns={columns}
            data={data?.length > 0 ? data : []}
            onClick={goToSinglePage}
            className="w-full"
            rowClass="hover:shadow-md cursor-pointer"
          />
        ) : (
          <div className="py-36 text-center">
            <div className="flex justify-center">
              <img src={EmptyState} className="w-auto" alt="no data" />
            </div>
            <h3 className="mt-5 text-xl font-bold">Food</h3>
            <p className="mt-2 text-sm text-[#9CA3AF]">
              You do not have any food yet.
            </p>
          </div>
        )}
        {!isSearchOpen && (
          <Pagination
            data={allFood}
            route={`admin/${outlet?.restaurant_name}/food/approved`}
          />
        )}
      </div>
    </div>
  );
}
